import { CountryCode } from "./countryData";
import { userIsCustomer } from "~/domains/user/utils/roles";

export const siteRegion = (): string => {
  const siteId: string = window?.SCHA?.config?.siteUid.trim().toUpperCase() ?? "";
  return siteId.split("-")[1] ?? "";
};

export const isSiteRegion = (region: string): boolean => region.trim().toUpperCase() === siteRegion();

const REGIONS: string[] = [CountryCode.JAPAN, CountryCode.INDIA, CountryCode.SINGAPORE];
export const siteHasCountryOriginEnabled = (): boolean => {
  const region: string = siteRegion();
  return REGIONS.includes(region);
};

export const canSeeCountryOrigin: boolean = (() => {
  return userIsCustomer() || siteHasCountryOriginEnabled();
})();
